<header>
  <a routerLink="/">
    <img class="header-logo" src="assets/logo.svg" alt="iamokay" />
  </a>
  <section class="account-details">
    <p class="logged-in">{{'LOGGED_IN_AS' | translate}} {{myFullName}}</p>
    <a (click)="onLogOut()">{{'LOGOUT' | translate}}</a>
  </section>
</header>

<nav>
  <ul class="nav-list">
    <li class="nav-item" routerLink="/dashboard/clients" routerLinkActive="active">
      <a>{{"CLIENTS" | translate}}</a>
    </li>
    <li class="nav-item" routerLink="/dashboard/chat" routerLinkActive="active">
      <a>{{"CHAT_WITH_CLIENT" | translate}}</a>
    </li>
    <li class="nav-item" routerLink="/dashboard/questionnaires" routerLinkActive="active">
      <a>{{"VITALITY_SCAN" | translate}}</a>
    </li>
    <li class="nav-item" *ngIf="coachingProgrammeUrl">
      <a target="_blank" [href]="coachingProgrammeUrl" download>{{"COACHING_PROGRAMME" | translate}}</a>
    </li>
    <li class="nav-item" routerLink="/dashboard/instructions" routerLinkActive="active">
      <a>{{"INSTRUCTIONS" | translate}}</a>
    </li>
    <li *ngIf="userRole === UserRole.SUPERADMIN" class="nav-item" routerLink="/dashboard/tenants" routerLinkActive="active">
      <a>{{ "TENANTS" | translate }}</a>
    </li>
    <li
      *ngIf="userRole === UserRole.ADMIN"
      class="nav-item"
      [routerLink]="['/dashboard/tenants', tenantId]"
      routerLinkActive="active">
      <a>{{ "COACHES" | translate }}</a>
    </li>
  </ul>
</nav>

<router-outlet></router-outlet>
